import React from "react";
import { useNavigate, useLocation } from "react-router";
import {
  MotifVerticalNavigation,
  MotifVerticalNavigationMenu,
  MotifVerticalNavigationMenuItem,
  MotifIcon,
  MotifVerticalNavigationContent,
  MotifIconButton,
} from "@ey-xd/motif-react";
import {
  MotifNavigationIcMenu24px,
  IconoirTrello,
  IconoirLifebelt,
  IconoirGroup,
} from "@ey-xd/motif-icon";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import "./CTSideNav.scss";

const CTSideNav: React.FC = () => {
  const [collapse, setCollapse] = React.useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const userPermissions: string[] = useSelector(
    (state: RootState) => state.UserProfileSlice.userPermissions
  );

  if (location.pathname === "/ct" || location.pathname === "/ct/") {
    return <></>;
  }

  const isBMOUser: boolean = userPermissions?.includes("system_bmo");

  return (
    <MotifVerticalNavigation className="ctsidenav-wrapper" collapse={collapse}>
      <MotifVerticalNavigationContent>
        <MotifIconButton
          aria-label="Toggle Menu"
          type="button"
          size="large"
          onClick={() => setCollapse(!collapse)}
        >
          <MotifIcon
            iconFunction={MotifNavigationIcMenu24px}
            size="24"
            title="Toggle Menu"
          />
        </MotifIconButton>
        {isBMOUser ? (
          <MotifVerticalNavigationMenu>
            <MotifVerticalNavigationMenuItem
              icon={
                <MotifIcon
                  iconFunction={IconoirTrello}
                  size="20"
                  title="Our Products"
                />
              }
              label="Our Products"
              onClick={() => navigate("/ct/")}
            >
              Our Products
            </MotifVerticalNavigationMenuItem>
            <MotifVerticalNavigationMenuItem
              icon={
                <MotifIcon
                  iconFunction={IconoirLifebelt}
                  size="20"
                  title="Commercial Hub"
                />
              }
              label="Commercial Hub"
              onClick={() => navigate("/")}
            >
              Commercial Hub
            </MotifVerticalNavigationMenuItem>
            <MotifVerticalNavigationMenuItem
              icon={
                <MotifIcon
                  iconFunction={IconoirGroup}
                  size="20"
                  title="BMO Team"
                />
              }
              label="BMO Team"
              onClick={() => navigate("/ct/bmo")}
            >
              BMO Team
            </MotifVerticalNavigationMenuItem>
          </MotifVerticalNavigationMenu>
        ) : (
          <MotifVerticalNavigationMenu>
            <MotifVerticalNavigationMenuItem
              icon={
                <MotifIcon
                  iconFunction={IconoirTrello}
                  size="20"
                  title="Our Products"
                />
              }
              label="Our Products"
              onClick={() => navigate("/ct/")}
            >
              Our Products
            </MotifVerticalNavigationMenuItem>
            <MotifVerticalNavigationMenuItem
              icon={
                <MotifIcon
                  iconFunction={IconoirLifebelt}
                  size="20"
                  title="Commercial Hub"
                />
              }
              label="Commercial Hub"
              onClick={() => navigate("/")}
            >
              Commercial Hub
            </MotifVerticalNavigationMenuItem>
          </MotifVerticalNavigationMenu>
        )}
      </MotifVerticalNavigationContent>
    </MotifVerticalNavigation>
  );
};

export default CTSideNav;
